import { apiServer } from "../config";

export async function getHTMLData(type: string) {
  const response = await fetch(apiServer + "/basic-page/load/" + type);
  return response.json();
}

export async function fetchTaggingInformationData() {
  const response = await fetch(
    apiServer + "/basic-page/load/tagging-information"
  );
  const data = await response.json();
  const dd = JSON.parse(data["data"]["body"]);
  return nestContentBlocks(dd["contentBlocks"]);
}

export const nestContentBlocks = (contentBlocks: any) => {
  const nestedBlocks: any[] = [];
  let currentBlock: any = null;
  contentBlocks.forEach((block: any) => {
    if (block.id === "") {
      // If the current block is not empty, push it to nestedBlocks
      if (currentBlock) {
        nestedBlocks.push(currentBlock);
      }
      // Start a new block
      currentBlock = { ...block, children: [] };
    } else {
      // Add the block with an ID to the children of the current block
      currentBlock.children.push(block);
    }
  });
  // Push the last block if it exists
  if (currentBlock) {
    nestedBlocks.push(currentBlock);
  }
  return nestedBlocks;
};
